import { render, staticRenderFns } from "./dtznhfb.vue?vue&type=template&id=2434eb7e&"
import script from "./dtznhfb.vue?vue&type=script&lang=js&"
export * from "./dtznhfb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports